/* eslint-disable no-param-reassign */
import $ from 'jquery'
import 'jquery.dynatable'
import Event from 'base/event'
import Hub from 'base/hub'
import { get } from 'base/lib/network'
import apiUrl from 'base/api_url'
import safeGet from 'lodash/get'
/*
Provides a visual log of certain events for admin users
*/
export default {
  // We have this `keysToHeaders` attribute to provide space saving
  // and user friendly names to column headers. We might want to just
  // generate `acceptableKeys` off of `keys(keysToHeaders)` but for
  // now, I like the explicitness of two different attributes.
  dumpEvents: [
    {
      event: Event.Collections.PRODUCT_HOVER,
      acceptableKeys: ['sku', 'geodis_quantity', 'restock_date'],
      keysToHeaders: {
        sku: 'sku',
        geodis_quantity: 'geodis',
        restock_date: 'restock',
      },
    },
    {
      event: Event.Collections.COLOR_HOVER,
      acceptableKeys: ['sku', 'geodis_quantity', 'restock_date'],
      keysToHeaders: {
        sku: 'sku',
        geodis_quantity: 'geodis',
        restock_date: 'restock',
      },
    },
    {
      event: Event.Product.COLOR_CHANGE,
      acceptableKeys: ['id', 'sku', 'orderable_state', 'geodis_quantity', 'restock_date'],
      keysToHeaders: {
        id: 'id',
        sku: 'sku',
        orderable_state: 'orderable state',
        geodis_quantity: 'geodis',
        restock_date: 'restock_date',
      },
    },
  ],

  navEvents: [
    Event.Collections.PAGE_VIEW,
    Event.Product.PAGE_VIEW,
    Event.App.ROUTE,
    Event.Page.PAGE_VIEW,
  ],

  async init() {
    this.makeInitialDom()
    this.listen()
    this.isVisible = false

    this.inventoryCounts = await get(apiUrl('inventory_counts/warehouse_inventory_counts'))

    this.location = window.location.href

    $(document).on('keyup', event => {
      // We are looking to match a combination of the `control` key and either
      // the `d` or `m` key. We have to have `m` here because on Windows machines
      // `cntrl-d` is mapped to the bookmarks shortcut. `cntrl-m` is one of the
      // few unmapped shortcuts on Windows so we are taking it over and keeping
      // `cntrl-d` for our Mac users who have their muscle memory trained!
      if (event.ctrlKey && [68, 77].includes(event.which)) {
        // Our product page is super complex and everything breaks if we push the
        // page over these 540px. But the layout makes it so the admin bar just
        // simply overlaps some of the main photo, which is great – we don't need
        // to push the page over for products.
        if (!window.location.pathname.includes('products')) {
          $('#page-wrap').velocity({
            left: this.isVisible ? 0 : 540,
          })
        }

        this.container.velocity({
          left: this.isVisible ? -540 : 0,
        })

        this.isVisible = !this.isVisible
      }
    })
  },

  listen() {
    this.dumpEvents.forEach(event => {
      Hub.sub(event.event, $.proxy(this.spitOut, this))
    })

    this.navEvents.forEach(event => {
      Hub.sub(event, $.proxy(this.updateDueToNavigation, this))
    })
  },

  // Builds initail dom container
  makeInitialDom() {
    const html = `\
<div class="admin-bar" style=" \
padding: 10px; \
box-sizing: border-box; \
height: 100%; \
background-color: #f8f8f8; \
width: 540px; \
top: 0;\
left: -540px; \
top: 0; \
z-index: 200000; \
position: fixed; \
color: #424242; \
overflow-y: scroll; \
border-bottom: 1px solid #dfe0e1;"> \
<!--<a href="javascript:;" style="position: absolute; right: -20px; top: 20px;">+/×</a>--> \
<table class="admin-bar__details" style="font-size: 14px; font-family: Helvetica;font-style: bold;display: inline-block;border-collapse: separate; border-spacing: 5px;"> \
</table> \
<a target="_blank" class="edit-btn fancy-button--light-grey" style="float: right;width: 30%;">Edit Collection</a> \
<ul class="data-list"></ul> \
</div>`

    this.container = $(html).prependTo($(document.body))
    this.list = this.container.find('.data-list')
  },

  spitOut(event, data) {
    const entry = this.makeEntry(event, data)
    this.list.prepend(entry)
  },

  makeEntry(event, data) {
    if (['Product.COLOR_CHANGE'].includes(event)) {
      data = data.variants
    }
    if (
      ['Collections.PRODUCT_HOVER', 'Collections.COLOR_HOVER', 'Product.COLOR_CHANGE'].includes(
        event,
      ) &&
      this.inventoryCounts != null
    ) {
      data.forEach(datum => {
        datum.geodis_quantity = safeGet(this, `inventoryCounts.28.${datum.id}`)
      })
    }

    const { acceptableKeys, keysToHeaders } = this.dumpEvents.find(e => event === e.event.name)

    const tableHeaders = acceptableKeys
      .map(key => {
        const header = keysToHeaders[key] || key
        return `<th data-dynatable-column='${key}'>${header}</th>`
      })
      .join('')

    const table = $(`<table class='dynatable'> \
<thead> \
${tableHeaders} \
</thead> \
<tbody> \
</tbody> \
</table>`)

    table.dynatable({
      dataset: {
        records: $.makeArray(data),
      },
      features: {
        paginate: false,
        sort: false,
        pushState: false,
        search: false,
        recordCount: false,
        perPageSelect: false,
      },
    })

    table.wrap('<li style="border-bottom: 1px solid #ebebeb; padding-bottom: 10px;"></li>')

    return table
      .parent('li')
      .prepend(
        `<h2 style="font-size: 14px; font-family: Helvetica; font-weight: bold; line-height: 14px;margin: 20px 0;">${event}</h2>`,
      )
  },

  updateDueToNavigation(event, data) {
    if (event === 'Collections.PAGE_VIEW') {
      this.updateEditButton({
        text: 'Edit Collection',
        href: `/backstage/collections/${data.collection.id}/edit`,
        display: 'block',
      })
      this.updateHeader(
        {
          id: data.collection.id,
          title: data.collection.title,
        },
        true,
      )
    } else if (event === 'Product.PAGE_VIEW') {
      this.updateEditButton({
        text: 'Edit Product',
        href: `/backstage/products/${data.product.id}/edit`,
        display: 'block',
      })
      this.updateHeader(
        {
          id: data.product.id,
          title: data.product.display_name,
        },
        true,
      )
    } else if (event === 'Page.PAGE_VIEW') {
      this.updateEditButton({
        text: 'Edit Page',
        href: `/backstage/pages/${data.permalink}/edit`,
        display: 'block',
      })
      this.updateHeader(
        {
          permalink: data.permalink,
        },
        true,
      )
    } else if (!data.path.includes('products') && !data.path.includes('collections')) {
      this.updateEditButton({
        text: '',
        href: '#',
        display: 'none',
      })
      this.updateHeader({}, false)
    }
  },

  updateHeader(params, visible) {
    const header = $('.admin-bar__details')
    header.empty()

    if (visible) {
      header.css('visibility', 'visible')

      Object.entries(params).forEach(([key, value]) => {
        const tr = document.createElement('tr')

        const key_td = document.createElement('td')
        key_td.innerHTML = `<strong>${key}:</strong>`
        tr.appendChild(key_td)

        const value_td = document.createElement('td')
        value_td.innerHTML = `    ${value}`
        tr.appendChild(value_td)

        header.append(tr)
      })
    } else {
      header.css('visibility', 'hidden')
    }
  },

  updateEditButton(params) {
    const edit_button = $('.edit-btn')

    edit_button.text(params.text)
    edit_button.attr('href', params.href)
    edit_button.css('display', params.display)
  },
}
